import { ref } from 'vue';
import { Sensor } from '@/entities/sensor';

export const useSensorRecord = () => ref<Sensor>({
  granularity: null,
  active: true,
  alarmsActive: false,
  createIssueFor: null,
  delayCreatingIssueBy: 0,
  hardwareId: '',
  humidityLastMeasurement: null,
  humidityLowerBound: null,
  humidityUpperBound: null,
  lastMeasuredAt: new Date(),
  entityItem: null,
  temperatureLastMeasurement: null,
  temperatureLowerBound: null,
  temperatureUpperBound: null,
  title: '',
  //need to send it like that in form
  alarmUsers: [],
});
